import { Component, Input, Output, EventEmitter } from "@angular/core";
import {
  VAIconRegistryService,
  chevronRight,
  slidersHorizontal,
  chevronDown,
} from "@va/core-library/icons";
import { Subscription } from "rxjs";
import { ComparativeAnalysisService } from "src/app/comparative-analysis/comparative-analysis.service";
import { Router } from "@angular/router";
import { UntypedFormControl } from "@angular/forms";
import { cloneThreeLevelTree } from "src/app/comparative-analysis/comparative-analysis-utils";

@Component({
  selector: "app-comparative-ticker-search-menu",
  templateUrl: "./comparative-ticker-search-menu.component.html",
  styleUrls: ["./comparative-ticker-search-menu.component.scss"],
})
export class ComparativeTickerSearchMenuComponent {
  @Input() isSearchMenuVisible;
  @Input() watchlistData;
  @Input() industryData;
  @Input() marketGeoData;
  @Input() selectedOption: Array<any>;
  @Input() suggestedTickerData;
  @Input() recentlyVisitedTickers;
  @Input() isCreateNewModalIndustryMenu: boolean = false;
  @Output() handleApply: EventEmitter<any> = new EventEmitter<any>();
  @Output() handleMenuChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() menuList = [
    {
      id: "suggested_peers",
      label: "Suggested Peers",
      isLeaf: true,
      dataProperty: "suggestedMenuData",
      disabled: false,
    },
    {
      id: "recently_visited",
      label: "Recently Visited",
      isLeaf: true,
      dataProperty: "recentlyVisitedMenuData",
      disabled: false,
    },
    {
      id: "industry",
      label: "Industry Peers",
      dataProperty: "industryMenuData",
    },
    {
      id: "watchlist",
      label: "Watchlists",
      isLeaf: false,
      dataProperty: "watchlistMenuData",
    },
  ];
  currenttabType;
  searchedTerm;
  delayMenuTimer: number | null = null;
  delaySelectTimer: number | null = null;
  // isSearchMenuVisible = false;
  activatedOptions = "suggested_peers";
  menuData = {
    industryMenuData: [],
    suggestedMenuData: [],
    recentlyVisitedMenuData: [],
    watchlistMenuData: [],
  };
  industryMenuData = [];
  compTableMenuData = [];
  customAnalysisMenuData = [];
  watchlistMenuData = [];
  marketCapData;
  geographyData;
  menuSearchCount = {
    industry: 1,
    watchlist: 1,
  };
  showNoResultsFound = false;
  defaultTabType = "Trend";

  //loaders
  isIndustryMenuApiInProgress = false;
  isCustomMenuApiInProgress = false;
  isCompMenuApiInProgress = false;
  isWatchlistMenuApiInProgress = false;
  isMarketGeoApiInProgress = false;

  // subscribers
  comparativeAnalysisMenuSubscriber: Subscription;
  marketGeoSubscriber: Subscription;
  routeParamSubscriber: Subscription;

  queryField: UntypedFormControl = new UntypedFormControl();

  constructor(
    private iconRegistry: VAIconRegistryService,
    private comparativeAnalysisService: ComparativeAnalysisService,
    public router: Router,
  ) {
    this.iconRegistry.registerIcons([
      chevronRight,
      slidersHorizontal,
      chevronDown,
    ]);
  }

  ngOnInit() {
    // this.isIndustryMenuApiInProgress = true;
    // this.isCustomMenuApiInProgress = true;
    // this.isCompMenuApiInProgress = true;
    // this.isWatchlistMenuApiInProgress = true;
    // this.isMarketGeoApiInProgress = true;
    // fetch menu data
    // this.fetchMenuData();
    // // fetch market geo data
    // this.marketGeoSubscriber = this.comparativeAnalysisService
    //   .fetchMarketAndGeoData()
    //   .subscribe((response: any) => {
    //     if (response.status === "success") {
    //       this.marketCapData = response.data.market_cap;
    //       this.geographyData = response.data.geographies;
    //     }
    //     this.isMarketGeoApiInProgress = false;
    //   });
  }

  ngOnChanges(changes) {
    if (changes.suggestedTickerData) {
      const index = this.menuList.findIndex((obj) => {
        return obj.id === "suggested_peers";
      });
      if (index > -1) {
        this.menuList[index].disabled =
          !this.suggestedTickerData || !this.suggestedTickerData.length;
      }
    }
    if (changes.recentlyVisitedTickers) {
      const index = this.menuList.findIndex((obj) => {
        return obj.id === "recently_visited";
      });
      if (index > -1) {
        this.menuList[index].disabled =
          !this.recentlyVisitedTickers || !this.recentlyVisitedTickers.length;
      }
    }
    if (
      changes.marketGeoData &&
      changes.marketGeoData.currentValue !== changes.marketGeoData.previousValue
    ) {
      this.marketCapData = { ...this.marketGeoData.market_cap };
      this.geographyData = [...this.marketGeoData.geographies];
    }
    if (
      changes.watchlistData &&
      changes.watchlistData.currentValue !==
        changes.watchlistData.previousValue &&
      this.watchlistData
    ) {
      this.menuData.watchlistMenuData = [...this.watchlistData];
      this.watchlistMenuData = [...this.watchlistData];
      this.menuSearchCount = {
        ...this.menuSearchCount,
        watchlist: this.watchlistMenuData.length,
      };
    }
    if (
      changes.industryData &&
      changes.industryData.currentValue !==
        changes.industryData.previousValue &&
      this.industryData
    ) {
      this.menuData.industryMenuData = [...this.industryData];
      this.industryMenuData = this.industryData
        ? cloneThreeLevelTree(this.industryData)
        : [];
      this.menuSearchCount = {
        ...this.menuSearchCount,
        industry: this.industryMenuData.length,
      };
    }
  }

  fetchMenuData(): void {
    // this.comparativeAnalysisMenuSubscriber = this.comparativeAnalysisService
    //   .fetchComparativeAnalysisMenuData("industry")
    //   .subscribe((response) => {
    //     if (response.status === "success") {
    //       this.menuData.industryMenuData = [...response.data.industry];
    //       this.industryMenuData = response.data.industry;
    //     }
    //     this.menuSearchCount = {
    //       ...this.menuSearchCount,
    //       industry: this.industryMenuData.length,
    //     };
    //     this.isIndustryMenuApiInProgress = false;
    //   });
    // this.comparativeAnalysisMenuSubscriber = this.comparativeAnalysisService
    //   .fetchComparativeAnalysisMenuData("watchlist")
    //   .subscribe((response) => {
    //     if (response.status === "success") {
    //       this.menuData.watchlistMenuData = [...response.data.watchlist];
    //       this.watchlistMenuData = response.data.watchlist;
    //     }
    //     this.menuSearchCount = {
    //       industry: this.industryMenuData.length,
    //       comp_table: this.compTableMenuData.length,
    //       custom_analysis: this.customAnalysisMenuData.length,
    //       watchlist: this.watchlistMenuData.length,
    //     };
    //     this.isWatchlistMenuApiInProgress = false;
    //   });
  }

  clearDelaySelectTimer(): void {
    if (this.delaySelectTimer) {
      clearTimeout(this.delaySelectTimer);
      this.delaySelectTimer = null;
    }
  }

  clearDelayMenuTimer(): void {
    if (this.delayMenuTimer) {
      clearTimeout(this.delayMenuTimer);
      this.delayMenuTimer = null;
    }
  }

  // handleInputChange(text) {
  //   this.industryMenuData = getTreeFilterdData(
  //     text,
  //     this.menuData.industryMenuData,
  //   );
  //   this.compTableMenuData = getTreeFilterdData(
  //     text,
  //     this.menuData.compTableMenuData,
  //   );
  //   this.customAnalysisMenuData = getListFilterdData(
  //     text,
  //     this.menuData.customAnalysisMenuData,
  //   );
  //   this.watchlistMenuData = getListFilterdData(
  //     text,
  //     this.menuData.watchlistMenuData,
  //   );
  //   this.menuSearchCount = {
  //     industry: this.industryMenuData.length,
  //     comp_table: this.compTableMenuData.length,
  //     custom_analysis: this.customAnalysisMenuData.length,
  //     watchlist: this.watchlistMenuData.length,
  //   };
  //   this.activatedOptions = this.menuSearchCount.industry
  //     ? "industry"
  //     : this.menuSearchCount.comp_table
  //       ? "comp_table"
  //       : this.menuSearchCount.custom_analysis
  //         ? "custom_analysis"
  //         : this.menuSearchCount.watchlist
  //           ? "watchlist"
  //           : undefined;
  //   if (!this.activatedOptions && text) {
  //     this.showNoResultsFound = true;
  //   }
  // }

  handleVisibleChange(value) {
    if (!value) {
      this.activatedOptions = "industry";
      // this.queryField.reset();
    }
  }

  handleMenuItemClick(item, event) {
    if (item.isLeaf) {
      this.handleMenuChange.emit(item);
      this.closePopover();
    }
    if (event) {
      event.preventDefault();
    }
    if (item && item.disabled) {
      return;
    }
  }

  setOptionActivated(item, id): void {
    if (item.disabled) {
      return;
    }
    this.activatedOptions = id;
  }

  delaySetOptionActivated(item, id): void {
    this.clearDelaySelectTimer();
    this.delaySelectTimer = window.setTimeout(() => {
      this.setOptionActivated(item, id);
      this.delaySelectTimer = null;
    }, 100);
  }

  handleMenuItemMouseEnter(item, event) {
    event.preventDefault();
    this.delaySetOptionActivated(item, item.id);
  }

  handleMenuItemMouseLeave(item, event) {
    event.preventDefault();
    if (!item.isLeaf) {
      this.clearDelaySelectTimer();
    }
  }

  ngOnDestroy(): void {
    this.clearDelayMenuTimer();
    this.clearDelaySelectTimer();
  }

  handleMenuCancelButtonClick() {
    this.closePopover();
  }

  closePopover() {
    this.isSearchMenuVisible = false;
    document.getElementById("searchbox").blur();
  }

  handleMenuApplyButtonClick(data) {
    this.handleApply.emit(data);
    this.closePopover();
  }
}
